import React, { Component } from 'react';

class StatusIcon extends Component {

  render(){
    const { status, record, width, height } = this.props;
    if (!status) {
      return null;
    }
    if (record&&record.IsDisabled || status === 'disabled') {
      return <img src={"./images/status/status_disabled.svg"} width={width || '16px'} height={height || '16px'} style={{verticalAlign: 'sub'}} />;
    } else {
      return <img src={"./images/status/status_"+ status +".svg"} width={width || '16px'} height={height || '16px'} style={{verticalAlign: 'sub'}} />;
    }
  }
}

export default StatusIcon;
